<script setup lang="ts">
import { storeToRefs } from 'pinia';

import Container from '@/components/base/layout/Container.vue';
import InformationBanner from '@/components/base/layout/InformationBanner.vue';
import { NotificationsByType, useNotifications } from '@/stores/notifications';

const { notificationsByType } = storeToRefs(useNotifications());

const messageQueue: (keyof NotificationsByType)[] = ['errors', 'warnings', 'notices'];

const variantMapping = {
  errors: 'error',
  notices: 'success',
  warnings: 'warning',
} as const;
</script>

<template>
  <Container>
    <transition v-for="messageType in messageQueue" :key="messageType" name="fade">
      <InformationBanner
        v-if="notificationsByType[messageType].length"
        class="my-4"
        :data-test="`flash-message-${messageType}`"
        :variant="variantMapping[messageType]"
      >
        <span v-html="notificationsByType[messageType].map((m) => m.message).join('<br />')" />
      </InformationBanner>
    </transition>
  </Container>
</template>
